import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

import { Accessibility, Analytics, Util } from 'core/services';
import { Subscription } from 'rxjs';

@Component({
    selector: 'xm-validation',
    styleUrls: ['./validation.scss'],
    templateUrl: './validation.html',
    standalone: false
})
export class XmValidationComponent implements OnInit, OnDestroy {
    @Input() public formCtrl: FormControl;
    @Input() public options: XmInputOptions;

    public validators: typeof Validators = Validators;
    public errorToShow: string = '';

    private analytics: Analytics;
    private accessibility: Accessibility;
    private subscriptions: Subscription[] = [];

    constructor(analytics: Analytics, accessibility: Accessibility) {
        Object.assign(this, { analytics, accessibility });
    }

    public ngOnInit(): void {

        // check form control errors on load
        if (this.formCtrl.errors) {
            this.errorToShow = this.formCtrl.errors.message;
        }
        this.subscriptions.push(this.formCtrl.statusChanges.subscribe(() => {
            let errorMessage: string = '';

            if (this.options.errors?.length && this.formCtrl.errors) {
                this.options.errors.forEach((errorOption: XmInputError) => {
                    const isRequired: boolean = this.formCtrl.errors[errorOption.code];
                    if (this.formCtrl.errors.code === errorOption.code || isRequired) {
                        errorMessage = errorOption.message || this.formCtrl.errors.message;

                        if (errorMessage && errorOption.code) {
                            this.analytics.fireValidationError(`${ errorOption.code }: ${ errorMessage }`);
                        }

                        // only announce when the error message has changed
                        if (errorMessage && this.errorToShow !== errorMessage && errorOption.liveMessage) {
                            this.accessibility.announceReaderText(errorMessage);
                        }
                    }
                });
            }

            this.errorToShow = errorMessage;
        }));
    }

    public ngOnDestroy(): void {
        Util.unsubscribeAll(this.subscriptions);
    }
}
